<template>
  <footer class="footer">
    <base-container>
      <div class="footer-content">
        <el-row justify="space-between" :gutter="10">
          <el-col :sm="24" :lg="7">
            <img src="../../assets/logo@2x.png" style="width: 153px" alt="" />
            <p style="margin-top: 2.5rem">
              方胡一怕豆春誰音誰活兆着忍坐發戶陽、高至蝶，同高字斗借六坐路兆什吧七大雲，刃家水頭跟東見合喝旁呀木，各久棵地春身安完嗎們牛氣圓，吹英隻位兔要枝習：具風主竹穿河再。
            </p>
            <p class="contact-us">聯絡我們</p>
            <el-row>
              <el-col class="contact-list">
                <img
                  src="../../assets/icon-phone@2x.png"
                  style="width: 24px"
                  alt=""
                />
                <span class="contact-text"
                  >Whatsapp / 電話 : +852 6376 1080</span
                >
              </el-col>
              <el-col class="contact-list">
                <img
                  src="../../assets/icon-time@2x.png"
                  style="width: 24px"
                  alt=""
                />
                <span class="contact-text"
                  >辦公時間 : 星期一 至 星期六 11:00 - 17:00</span
                >
              </el-col>
              <el-col class="contact-list">
                <img
                  src="../../assets/icon-address@2x.png"
                  style="width: 24px"
                  alt=""
                />
                <span class="contact-text"
                  >地址 : 九龍觀塘觀塘道404號時運工業大廈5A</span
                >
              </el-col>
            </el-row>
          </el-col>
          <el-col :sm="24" :lg="16">
            <el-row justify="space-between">
              <el-col :span="4" class="single-list">
                <p class="list-title">關於易到家</p>
                <ul class="list">
                  <li>服務</li>
                  <li>物流資訊</li>
                  <li>常見問題</li>
                  <li>最新消息</li>
                  <li>代購流程教學</li>
                  <li>代運流程教學</li>
                </ul>
              </el-col>
              <el-col :span="4" class="single-list">
                <p class="list-title">各國購物網站</p>
                <ul class="list">
                  <li>美國品牌</li>
                  <li>日本品牌</li>
                  <li>英國品牌</li>
                  <li>台灣品牌</li>
                  <li>澳洲品牌</li>
                  <li>德國品牌</li>
                </ul>
              </el-col>
              <el-col :span="6" class="single-list">
                <p class="list-title">服務收費</p>
                <ul class="list">
                  <li>美國代購\代運收費</li>
                  <li>日本代購\代運收費</li>
                  <li>英國代購\代運收費</li>
                  <li>台灣代購\代運收費</li>
                  <li>澳洲代購\代運收費</li>
                  <li>德國代購\代運收費</li>
                  <li>取貨方式</li>
                  <li>額外保障</li>
                  <li>其他費用</li>
                </ul>
              </el-col>
              <el-col :span="3" class="single-list">
                <p class="list-title">代購服務</p>
                <ul class="list">
                  <li>何謂代購</li>
                  <li>美國代購</li>
                  <li>日本代購</li>
                  <li>英國代購</li>
                  <li>台灣代購</li>
                  <li>澳洲代購</li>
                  <li>德國代購</li>
                </ul>
              </el-col>
              <el-col :span="3" class="single-list w3-right-align">
                <p class="list-title">代運服務</p>
                <ul class="list">
                  <li>何謂代運?</li>
                  <li>美國代運</li>
                  <li>日本代運</li>
                  <li>英國代運</li>
                  <li>台灣代運</li>
                  <li>澳洲代運</li>
                  <li>德國代運</li>
                </ul>
              </el-col>
              <el-col :span="3" class="single-list">
                <p class="list-title">折扣優惠</p>
                <ul class="list">
                  <li>積分計劃</li>
                </ul>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="bottom-footer">
        <el-row justify="space-between">
          <el-col :sm="24" :lg="10">
            <p>© Etouka. All rights reserved.</p>
          </el-col>
          <el-col class="w3-right-align" :sm="24" :lg="14">
            <span>多元代款</span>
            <img
              src="../../assets/payment-paypal@2x.png"
              style="width: 70px"
              alt=""
              class="icon-footer"
            />
            <img
              src="../../assets/payment-visa@2x.png"
              style="width: 50px"
              alt=""
              class="icon-footer"
            />
            <img
              src="../../assets/payment-mastercard@2x.png"
              style="width: 50px"
              alt=""
              class="icon-footer"
            />
            <img
              src="../../assets/payment-jcb@2x.png"
              style="width: 50px"
              alt=""
              class="icon-footer"
            />
            <img
              src="../../assets/payment-unionpay@2x.png"
              style="width: 50px"
              alt=""
              class="icon-footer"
            />
          </el-col>
        </el-row>
      </div>
    </base-container>
  </footer>
</template>

<style scoped>
.footer {
  background-color: C4C4C4;
  padding: 5rem 0 1.5rem 0;
  min-width: 990px;
}

.footer-content {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding-bottom: 3rem;
}

.list-title {
  margin-bottom: 1rem;
}

.list {
  list-style-type: none;
  /* margin-bottom: 2rem; */
}

.single-list:not(:last-of-type),
.single-list:not(:first-of-type) {
  margin-left: 1.3rem;
}

.contact-us,
.list-title {
  color: #7a3d87;
  font-weight: 700;
}

.contact-us {
  margin-top: 2.4rem;
}

.contact-text {
  margin-left: 0.5rem;
  font-size: 13px;
  /* margin-top: 5.5rem; */
}

.contact-list {
  margin-top: 0.7rem;
}

.bottom-footer {
  padding-top: 2rem;
}

.bottom-footer .el-row {
  align-items: center;
}

.icon-footer {
  margin-left: 1rem;
}
</style>